<template>
    <div>
        <b-container v-if="loaded">
            <b-row>
                <b-col>

                    <h3>Payment information</h3>
                    <div v-if="showConnectButton" class="py-4">
                        <p>To accept payment from your event attendees, please connect your Stripe account</p>
                        <a :href="connectUrl" class="tb-button tb-button--blue tb-button--small px-4 py-3">
                            Connect Stripe account
                        </a>
                    </div>

                    <div v-if="showAuthSuccess" class="py-4">
                        <p>In Oauth callback</p>
                        <pre>
                            {{stripe_oauth_response_code}}
                        </pre>
                    </div>

                    <div v-if="showDisconnectButton" class="py-4">

                        <p>Your Stripe account is connected - you can accept online payment for your events</p>

                        <pre>  Stripe User ID: {{client.stripe_user_id}}  </pre>
                        <p>If you no longer wish to accept payments, you can disconnect your Stripe account</p>

                        <button v-on:click="disconnectStripe" class="tb-button tb-button--red tb-button--small px-4 py-3">
                            Disconnect Stripe
                        </button>
                    </div>

                </b-col>   
            </b-row>
        </b-container>
    </div>
</template>

<script>

    const stripe_client_id = process.env.VUE_APP_STRIPE_CLIENT_ID;
    import clientRepository from "@/repository/clients";

    export default {
        data(){
            return {
                stripe_client_id,
                client:{},
                stripe_oauth_response_code:null,
                loaded:false
            }
        },
        computed:{
            connectUrl(){
                return "https://connect.stripe.com/oauth/authorize?response_type=code&client_id=" + stripe_client_id + "&scope=read_write";
            },
            showConnectButton(){
                return this.client.stripe_user_id == null && this.stripe_oauth_response_code == null;
            },
            showAuthSuccess(){
                return this.stripe_oauth_response_code !== null;
            },
            showDisconnectButton(){
                return this.client.stripe_user_id !== null;
            }
        },

        mounted(){
            let client_id = this.$store.getters.user.client.id;

            clientRepository.getById(client_id)
                .then(response => {
                    this.client = response.data;
                    if(this.$route.query.code){
                        this.stripe_oauth_response_code = this.$route.query.code;
                        this.oauthCallback(this.stripe_oauth_response_code)
                    }
                    this.loaded = true;
                })
                .catch(error=>console.log(error));
        },
        methods:{
            oauthCallback(stripe_oauth_response_code){
                clientRepository.authorizeWithStripe(this.client.id, stripe_oauth_response_code)
                    .then(response => {
                        console.log(response.data)
                    })
                    .catch(error=>console.log(error));
            },

            disconnectStripe() {
                clientRepository.disconnectStripeAuthorization(this.client.id)
                    .then(response => {
                        console.log(response.data)
                        this.client.stripe_user_id = null;
                    })
                    .catch(error=>console.log(error));
            }
        }

    }
</script>

<style lang="scss" scoped>

</style>